import type { TFunction } from 'i18next';
import { getPdfPageCount } from '@/shared/lib/pdf/getPdfPageCount';
import { FILE_UPLOAD_CONFIG } from './constants';

/**
 * PDF のページ数バリデーション
 *
 * 上限（{@link FILE_UPLOAD_CONFIG.maxPages}）を超えたらエラーメッセージを返す。
 * パース失敗時（暗号化・破損等）は検証をスキップして通過させ、BE/Bedrock 側の検証に委ねる
 * （正当な PDF を誤ってブロックしないことを優先）。
 *
 * @param file - 対象の PDF ファイル
 * @param t - i18n の翻訳関数
 * @returns エラーメッセージ（上限超過時）／ null（通過）
 */
export const validatePdfPageCount = async (file: File, t: TFunction): Promise<string | null> => {
  try {
    const pageCount = await getPdfPageCount(file);
    if (pageCount > FILE_UPLOAD_CONFIG.maxPages) {
      return t('ai.pdf-upload.errors.max-pages-exceeded', {
        max: FILE_UPLOAD_CONFIG.maxPages,
      });
    }
  } catch {
    // パースできない PDF はページ数検証をスキップ（誤って正当な PDF をブロックしない）
  }
  return null;
};
